import { useFilters } from "../../../../Components/Filters/Filters.hook";
import { Button } from "shared-components/Components/Buttons/web";
import { ListIcon } from "shared-components/Components/CustomIcons/ListIcon/web";
import { LocationIconMap } from "shared-components/Components/CustomIcons/LocationIconMap/web";

export const ButtonMapToggle = ({ map, setMap }) => {
	const { changeFilters } = useFilters();

	return (
		<Button
			type="noStyles"
			className={!map? "btn-secondary order-filter-btn" : "btn-secondary order-filter-btn-map"}
			onClick={() => {
				let showMap = !map;
				if (!showMap) changeFilters({ map_bounds: null, mapView: false, map_polygon: null });
				setMap(showMap);
			}}>
			{map?  <ListIcon width={16}/> : <LocationIconMap width={16}  />}
			{map ? "Ver Listado" : "Ver Mapa"}
		</Button>
	);
};

